import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { PrimengModule } from '../../modules/primeng/primeng.module';
import {AppFooterComponent, AppMainComponent, AppMenuComponent, AppTopBarComponent, AppMenuitemComponent, AppConfigComponent, FileViewerComponent, ShareEmailComponent} from './component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import {MenuService, AuthService
} from './service';
import { MessageService } from 'primeng/api';
import { ApiErrorInterceptor, ApiRequestInterceptor, ApiResponseInterceptor, ApiEmptyResponseInterceptor } from './interceptor';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { DatePipe } from './pipe/date.pipe';
import { HighlightDirective } from './lib/highlight.directive';
import { SafeUrlPipe } from './pipe/safeUrl/safe-url.pipe';
import { HighchartsChartModule } from 'highcharts-angular';
import { HighlightPipe } from './pipe/highlight/highlight.pipe';
import { CrudGridComponent } from './component/crud-grid/crud-grid.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { SidebarFilterComponent } from './component/sidebar-filter/sidebar-filter.component';
import { TimerPipe } from './pipe/timer/timer.pipe';
@NgModule({
  declarations: [ AppFooterComponent, AppMainComponent,AppConfigComponent
    , AppMenuComponent, AppTopBarComponent, AppMenuitemComponent,HighlightPipe,TimerPipe, DatePipe,SafeUrlPipe, HighlightDirective, CrudGridComponent,SidebarFilterComponent,ShareEmailComponent ,FileViewerComponent,
  ],
  imports: [
    PrimengModule,
    CommonModule,
    RouterModule,
    FormsModule,
    FontAwesomeModule,
    ReactiveFormsModule,
    HighchartsChartModule,
    PdfViewerModule
  ],
  providers: [
    MessageService, MenuService, AuthService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiRequestInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiResponseInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiErrorInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiEmptyResponseInterceptor,
      multi: true
    }
  ],
  exports: [PrimengModule,DatePipe,TimerPipe,HighlightDirective,HighlightPipe,SafeUrlPipe,CrudGridComponent,SidebarFilterComponent,FileViewerComponent,ShareEmailComponent]
})
export class AppCommonModule { }
